const TOKEN = /\{\{\s*([a-zA-Z0-9_.]+)((?:\s*\|\s*[a-zA-Z]+(?::"[^"]*")?)*)\s*\}\}/g;
function toText(v) {
    if (v === undefined || v === null)
        return "";
    if (Array.isArray(v))
        return v.join(", ");
    if (typeof v === "boolean")
        return v ? "yes" : "no";
    return String(v);
}
function applyFilter(value, name, arg) {
    switch (name) {
        case "firstName": {
            const s = toText(value).trim();
            return s.split(/\s+/)[0] ?? "";
        }
        case "join":
            return Array.isArray(value) ? value.join(arg ?? ", ") : toText(value);
        case "default":
            return value === undefined || value === "" || (Array.isArray(value) && value.length === 0)
                ? (arg ?? "")
                : value;
        default:
            return value;
    }
}
export function renderTemplate(text, ctx) {
    return text.replace(TOKEN, (_m, path, filters) => {
        let value;
        const [root, ...rest] = path.split(".");
        if (root === "clinic")
            value = toText(ctx.clinic[rest.join(".")]);
        else if (root === "answers") {
            const v = ctx.answers[rest.join(".")];
            value = Array.isArray(v) ? v : v === undefined ? undefined : toText(v);
        }
        else
            value = "";
        for (const f of filters
            .split("|")
            .map((s) => s.trim())
            .filter(Boolean)) {
            const m = /^([a-zA-Z]+)(?::"([^"]*)")?$/.exec(f);
            if (m)
                value = applyFilter(value, m[1] ?? "", m[2]);
        }
        return toText(value);
    });
}
/** For renderers that must emit HTML. */
export function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] ?? c);
}
//# sourceMappingURL=template.js.map